App.namespace.wrap('es6.shared.expiring_data_manager', function (options = {}) {
  const storageManager = App.es6.shared.storage_manager().init('local')

  const {
    storageItemName, // Name under which data is stored in Local Storage
    ajaxEndpoint,    // Endpoint to get new data
    expirationTime,  // Time after which data from Local Storage is expired and needs to be updated
    isValidResponse = () => true, // Checks the shape of the ajax response before using/caching it
    emptyValue = null // Resolved/cached instead, when the ajax response fails the shape check
  } = options

  const STORAGE_ITEM_NAME = storageItemName
  const AJAX_ENDPOINT = ajaxEndpoint
  const EXPIRATION_TIME = expirationTime || 24 * 60 * 60 * 1000 // Default expiration time is 24 hours

  /**
   * Get data previously saved in Local Storage
   *
   * @returns {Array|null} - Array with data object, null if the Storage is empty or data is too old
   */
  const getSavedData = () => {
    const savedData = storageManager.get(STORAGE_ITEM_NAME)
    if (savedData) {
      const { data, savedAt } = JSON.parse(savedData)
      if (data && isNotExpired(savedAt)) {
        return data
      }
    }
    return null
  }

  /**
   * Save tags in Local Storage
   *
   * @param {Array} data - Object with data to save
   * @returns {boolean} - True if save succeeded, false if failed
   */
  const saveToLocalStorage = (data) => {
    const savedAt = new Date()
    return storageManager.set(STORAGE_ITEM_NAME, JSON.stringify({ data, savedAt }))
  }

  /**
   * Check if given date is not older than specified time
   *
   * @param {string} dateToCheck - JavaScript datestamp
   * @returns {boolean} - Returns true if the date is not yet expired, false if it is
   */
  const isNotExpired = (dateToCheck) => {
    return ((new Date()) - (new Date(dateToCheck))) < EXPIRATION_TIME
  }

  /**
   * Get data from Local Storage or Ajax request if needed
   *
   * A malformed or failed ajax response is never cached; it resolves to emptyValue instead.
   *
   * @returns {Promise} A jQuery promise that resolves to an object with the data
   */
  const get = () => {
    const deferred = $.Deferred()

    const data = getSavedData()
    if (data) {
      deferred.resolve(data)
    } else {
      $.get(AJAX_ENDPOINT).then((response) => {
        if (!isValidResponse(response)) {
          deferred.resolve(emptyValue)
          return
        }
        saveToLocalStorage(response)
        deferred.resolve(response)
      }).fail(() => {
        deferred.resolve(emptyValue)
      })
    }

    return deferred.promise()
  }

  return {
    get
  }
})